import classNames from 'classnames';
import { useCallback, useContext, useMemo } from 'react';
import { CreateReportModal } from '@/modules/common/components/modals/CreateReportModal.tsx';
import { useRegisterTypeStrings } from '@/modules/common/hooks/useRegisterTypeStrings.tsx';
import { InfoCard, ModalProviderContext, SelectOption } from 'ui';
import { FileDisabledIcon, LockIcon } from 'ui/icons';
import { ReportType } from 'api';

export const DistributionReports = () => {
  const { openModal } = useContext(ModalProviderContext);
  const getRegisterTypeStrings = useRegisterTypeStrings();
  const handleOpenCreateReportModal = useCallback(
    (reportType: ReportType) => {
      // todo: change in case usage for investor
      openModal(CreateReportModal, { reportType });
    },
    [openModal],
  );

  const options = useMemo<SelectOption<ReportType>[]>(() => {
    return [
      {
        label: `${getRegisterTypeStrings('Dividend', { capitalize: true })} report`,
        value: ReportType.Dividend,
      },
      {
        label: `Investor ${getRegisterTypeStrings('dividend')} report`,
        value: ReportType.InvestorDistribution,
      },
      {
        label: `${getRegisterTypeStrings('Dividend', { capitalize: true })} statement report`,
        value: ReportType.DividendStatement,
      },
    ];
  }, [getRegisterTypeStrings]);

  return (
    <InfoCard title="Common Reports" classes={{ content: 'p-0' }}>
      <div className="gap-2 px-6 py-3">
        {options.map(({ label, value }, index) => (
          <div
            key={`${value}_${index}`}
            onClick={value ? handleOpenCreateReportModal.bind(null, value) : undefined}
            className={classNames('flex gap-3 items-center rounded-lg py-2.5 px-3', {
              'cursor-pointer': !!value,
              'hover:bg-gray-100': !!value,
            })}
          >
            <div className="flex items-center justify-center w-10 h-10 bg-gray-200 rounded-full">
              <img src={FileDisabledIcon} alt="file" />
            </div>
            <span className="text-sm">{label}</span>
            {!value && <img src={LockIcon} alt="blocked" className="ml-auto" />}
          </div>
        ))}
      </div>
    </InfoCard>
  );
};
